var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook logo",
    clipPath: "url(#clip0_2069_865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.96563 16.0665V8.84036H0V6.23861H1.96563V4.01638C1.96563 2.27013 3.12673 0.666504 5.80216 0.666504C6.8854 0.666504 7.68641 0.767451 7.68641 0.767451L7.62329 3.19704C7.62329 3.19704 6.80639 3.18931 5.91496 3.18931C4.95016 3.18931 4.79558 3.62151 4.79558 4.33886V6.23861H7.69998L7.57361 8.84036H4.79558V16.0665H1.96563Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2069_865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.69998,
    height: 15.4,
    fill: "white",
    transform: "translate(0 0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a5650d3511c3c7feb704bc65f72157e5.svg";
export { ForwardRef as ReactComponent };